import {useMutation} from 'react-query'

import {mutations} from '../../mutations'

export const useDeleteScheduledExports = () => {
  return useMutation(mutations.deleteScheduledExports)
}
